import type { SVGProps } from 'react';
const DawnFlagGT = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-GT_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-GT_svg__a)">
      <path fill="#63AEE3" d="M14.667 0H22v16h-7.333z" />
      <path fill="#63AEE3" fillRule="evenodd" d="M0 16h7.333V0H0z" clipRule="evenodd" />
      <path
        fill="#628A40"
        fillRule="evenodd"
        d="M13.095 6.8c.369 0 .667.299.667.667 0 .987-.505 1.858-1.27 2.357a.667.667 0 0 1-.728-1.117c.398-.26.665-.716.665-1.24 0-.368.298-.667.666-.667m-4.19 0c.368 0 .667.299.667.667 0 .547.29 1.02.717 1.272a.667.667 0 0 1-.678 1.148 2.8 2.8 0 0 1-1.373-2.42c0-.368.299-.667.667-.667"
        clipRule="evenodd"
      />
      <path
        fill="#DCC26D"
        fillRule="evenodd"
        d="M11 8.533c.578 0 1.047-.477 1.047-1.066S11.578 6.4 11 6.4c-.579 0-1.048.477-1.048 1.067 0 .589.47 1.066 1.048 1.066"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagGT;
